import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import styled from "react-emotion";
import { spaces } from "./layout/layoutConfig";
import { BREAKPOINTS, breakpoints, Space, spacing } from "./layout";
const formatBreakpointTableRow = () => {
    let rows = [];
    BREAKPOINTS.forEach(([px, name], i) => {
        const [nextPx] = i < BREAKPOINTS.length - 1 ? BREAKPOINTS[i + 1] : [Infinity];
        rows = rows.concat([
            ` - Name: ${name}`,
            `   Min: ${px}`,
            `   Max: ${nextPx - 1}`
        ]);
    });
    return rows.join("\n");
};
const Test = styled("div") `
  ${spacing.ma4};
  ${spacing.pb4};
  background: rgba(255, 0, 0, 0.5);
`;
export default () => markdown `
# Breakpoints
These are the available breakpoints:
~~~table
rows:
${formatBreakpointTableRow()}
~~~
We provide shortcuts for common usage scenarios:
~~~
${Object.keys(breakpoints).join(", ")}
~~~
To customize the spacing variables, change \`theme/layout/layoutConfig.js\` and then run \`yarn make-layout\`.
## Usage example
~~~code|javascript
import styled, { css } from 'react-emotion'
import { breakpoints as bp } from 'materials/index'
const Heading = styled('h1')\`
  font-size: 20px;
  \${bp.large\`
    font-size: 40px;
  \`}
  \${bp.mediumOnly\`
    font-size: 80px;
  \`}
\`
~~~
# Spacing
~~~hint|directive
Components should never define their outer margins or paddings: they need to be placeable anywhere and spacing around them may change, so they should leave that concern to the layout.
~~~
Spaces define the distance beween components in a layout. They follow a concise but powerful naming convention:
~~~table
rows:
  - Name: pv0
    Type: <p>padding
    Sides: <v>ertical
    Space: <0> none
  - Name: mb1
    Type: <m>argin
    Sides: <b>ottom
    Space: <1>
  - Name: pl2
    Type: <p>adding
    Sides: <l>eft
    Space: <2>
  - Name: mh4
    Type: <m>argin
    Sides: <h>orizontal
    Space: <4>
~~~
These spaces are defined:
~~~table
rows:
${spaces.map((sp, i) => `  - Index: ${i}\n    Value: ${sp}px`).join("\n")}
~~~
To customize the spacing variables, change \`theme/layout/layoutConfig.js\` and then run \`yarn make-layout\`.
## Using the \`spacing\` constants
${(<ReactSpecimen noSource span={3}>
    <Test>XXX</Test>
  </ReactSpecimen>)}
~~~code|span-3
import { spacing } from './layout'
const Test = styled('div')\`
\$\{spacing.ma4}
\$\{spacing.pb4}
  background: rgba(255,0,0,0.5);
\`
~~~
## Using the \`Space\` component
${(<ReactSpecimen noSource span={3}>
    <Space ma4 pb4>
      XXX
    </Space>
  </ReactSpecimen>)}
~~~code|span-3
<Space ma4 pb4>
  XXX
</Space>
~~~
# Container
Container centers the content horizontally and add horizontal padding. You can use either the React component, or mix the container css into your style.
~~~code|lang-js,span-3
import { Container } from '…/materials/index'
<Container>
  <MyContent />
</Container>
~~~
~~~code|lang-js,span-3
import { container } from '…/materials/index'
const MyStyledComponent = styled('div')\`
\${container};
background-color: teal;
\`
~~~
`;



// WEBPACK FOOTER //
// ./src/theme/layout.docs.tsx